import React from 'react';
import classNames from 'classnames';
import { ILeftVsRightKeys, IStatistics } from 'twain-sport-fe-mono/interfaces';
import { StatisticsValueType } from 'twain-sport-fe-mono/enums';
import { formatStatisticsValue } from 'twain-sport-fe-mono/utils/formatStatisticsValue';
import classes from './GridValue.module.scss';

interface IProps {
    value: IStatistics;
    align: ILeftVsRightKeys;
}

export const GridValue: React.FC<IProps> = (props) => (
    <div
        className={classNames(classes.value, classes[props.align], {
            [classes.withPrefix]: props.value?.prefix,
        })}
    >
        <div className={classes.wrapper}>
            {props.value ? (
                <>
                    <span>
                        {formatStatisticsValue(props.value)}
                        {props.value.type === StatisticsValueType.PERCENTAGE && (
                            <span className={classes.percentageSign}>%</span>
                        )}
                    </span>
                    {!!props.value.prefix && (
                        <span className={classes.prefix}>({props.value.prefix})</span>
                    )}
                </>
            ) : (
                '--'
            )}
        </div>
    </div>
);
